import { TableFieldModel } from '@/model/TableList'
import { formatCurrency } from '@/utils/formatters'
// import { payTypeList } from '@/utils/index'

export const MarketFeeAccountFieldData: TableFieldModel[] = [
  // {
  //   componentType: 'el-select',
  //   componentName: '下拉选择',
  //   fieldKey: 'accountType',
  //   fieldName: '支付类型',
  //   convert: context => {
  //     const { rowData } = context
  //     const { account = {}} = rowData
  //     return payTypeList.find(kk => kk.id === account.type)?.name
  //   }
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '下拉选择',
  //   fieldKey: 'accountName',
  //   fieldName: '账户名',
  //   convert: context => {
  //     const { rowData } = context
  //     const { account } = rowData
  //     return account?.name
  //   }
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '下拉选择',
  //   fieldKey: 'accountNo',
  //   fieldName: '账号',
  //   convert: context => {
  //     const { rowData } = context
  //     const { account } = rowData
  //     return account?.no
  //   }
  // },
  // {
  //   componentType: 'el-select',
  //   componentName: '下拉选择',
  //   fieldKey: 'accountBank',
  //   fieldName: '开户行',
  //   convert: context => {
  //     const { rowData } = context
  //     const { account } = rowData
  //     return account?.bank
  //   }
  // }
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'accontAlias',
    fieldName: '账户信息',
    convert: context => {
      const { rowData } = context
      const { account = {}} = rowData
      return account.alias
    }
  }
]

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fee',
    fieldName: '费用',
    textAlign: 'right',
    formatter: (row: any) => {
      if (row.status && String(row.status).includes('待定')) {
        const s = String(row.fee ?? '').trim()
        return s.endsWith('%') ? s : (s ? `${s}%` : '')
      }
      return formatCurrency(row.fee)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'feeType',
    fieldName: '费用类型'// 系统生成，人工生成
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'status',
    fieldName: '状态'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'paymentAccount',
    fieldName: '付款账户'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'times',
    fieldName: '申请次数',
    width: 100
  },
  ...MarketFeeAccountFieldData
]

export const MarketFeeFieldData = TableField
